import GraphqlProvider from './GraphqlProvider';

export default GraphqlProvider;
